import { createTheme } from "@mui/material/styles";

export const MuiThemeContext = createTheme();
